module.exports = "float fmod(float x, float m, float m_inv) {\nreturn x - m * floor(x * m_inv);\n}"